import { SuperChartConfiguration } from '../../proto/generated/superchart-page'
import { TradingCalendars } from '../../proto/generated/trading-calendar'
import api from './axiosClient'
import { AppDispatch } from '../../store'
import { setChartTypes, setDateRanges, setExchangeTradingSessions, setIndicators, setTimeBuckets, setTradingCalendarData } from '../../reducer/chart.reducer'

export const getConfiguration = async (args: { dispatch: AppDispatch }): Promise<SuperChartConfiguration> => {

    try {
        const url = `/supercharts/configuration`
        const response = await api.get(url, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        });

        const decodedData = SuperChartConfiguration.decode(new Uint8Array(response.data))
        args.dispatch(setChartTypes(decodedData.chartTypes))
        // args.dispatch(setDateRanges(decodedData.dateRanges))
        args.dispatch(setTimeBuckets(decodedData.timeBuckets))
        args.dispatch(setIndicators(decodedData.indicators))
        args.dispatch(setExchangeTradingSessions(decodedData.exchangeTradingSessions))

        return decodedData;
    } catch (error) {
        // Deliberately leaves any previously loaded configuration in place: clearing it here
        // turns a transient fetch failure into a chart with no indicators or timeframes.
        console.error('[supercharts] configuration fetch failed', error)
        throw error;
    }
}

export const getTradingCalenderData = async (args: { dispatch: AppDispatch }): Promise<TradingCalendars> => {
    return new Promise((resolve, reject) => {
        const url = `/supercharts/trading-calendar/all`
        api.get(url, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const decodedData = TradingCalendars.decode(new Uint8Array(response.data))
                args.dispatch(setTradingCalendarData(decodedData.tradingCalendersData))
                resolve(decodedData)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
